import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import FullExtent from './FullExtent';
import { MapButtonGroup } from './styles';

const TopControls = styled(MapButtonGroup)`
  position: absolute;
  right: 10px;
  top: unset;
  bottom: 50%;
  margin-bottom: calc(-43.5px - 20px);
  button {
    border-radius: 0 !important;
  }
`;

const Controls = ({ areFeaturesEmpty, zoomToFullExtent }) =>
  areFeaturesEmpty ? null : (
    <TopControls>
      <FullExtent zoomToFullExtent={zoomToFullExtent} />
    </TopControls>
  );

Controls.propTypes = {
  areFeaturesEmpty: PropTypes.bool.isRequired,
  zoomToFullExtent: PropTypes.func.isRequired,
};

export default Controls;
